<template>
  <div>
    <div class="aws-sku-edit-images">
      <div v-if="!isEmpty" class="aws-sku-edit-images-wrapper">
        <div
          v-for="(item, index) in list"
          :key="item.amzSkuImgCode"
          class="aws-sku-edit-images-item"
        >
          <div class="aws-sku-edit-images-item-box">
            <el-image fit="scale-down" :src="item.displayImageUrl" />

            <div class="aws-sku-edit-images-item-shadow">
              <div>
                <span @click="preivew(index)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!disabled" @click="check(item)" class="ml-2">
                  <i class="el-icon-check"></i>
                </span>
                <span v-if="!disabled" @click="remove(item)" class="ml-2">
                  <i class="el-icon-delete-solid"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isEmpty" class="aws-sku-edit-images-empty">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>

    <div v-show="false" id="preview-images" v-viewer="{ movable: true }">
      <img
        v-for="item in displayImages"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { VXETable } from 'vxe-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    limit: { type: Number, default: 10 },
    disabled: { type: Boolean, default: false },
    amzSkuCode: { type: String, default: '' },
  },
  data() {
    return { list: [] }
  },
  computed: {
    isEmpty() {
      return !this.list?.length
    },
    displayImages() {
      return lodash.map(this.list, 'displayImageUrl')
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzSkuCode) return

      const res = await this.$api
        .ecomAmzSkuImageListApi({ amzSkuCode: this.amzSkuCode })
        .catch(() => null)
      if (!res) return

      this.list = res.body?.data || []
    },
    async upload() {
      const files = await this.readFile()
      if (!files?.length) return

      const tasks = Array.from(files).map((item) =>
        this.$api
          .SYS_UPLOAD(item)
          .then((res) => ({
            originImageCode: res.body.fileId,
            originImageUrl: res.body.url,
            originImageSpec: item.type,
          }))
          .catch(() => null)
      )

      if (this.loadingOpen()) return
      const results = await Promise.all(tasks)
      if (results.includes(null)) {
        this.$message.warning(
          this.$l('tips_warning_upload_doc_error') ||
            '文件上传失败，请联系管理员'
        )
        this.loadingClose()
        return
      }

      const res = await this.$api
        .ecomAmzSkuImageUploadApi({
          amzSkuCode: this.amzSkuCode,
          listImage: results,
        })
        .catch(() => null)
      this.loadingClose()

      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })

      this.getData()
      this.$emit('reload')
    },
    async readFile() {
      const types = ['jpeg', 'JPEG', 'jpg', 'JPG', 'png', 'PNG', 'gif', 'GIF']

      const { files = [] } = await VXETable.readFile({
        multiple: true,
        types,
      }).catch(() => ({}))

      if (!files?.length) return

      if (files.length > this.limit) {
        const msg =
          (this.$l('INDEX.tips_uploadAwsSkuImage_limit_selection') ||
            '当前限制选择') +
          `  ${this.limit}  ` +
          (this.$l('INDEX.tips_uploadAwsSkuImage_limit_picture') || '张图片') +
          ',' +
          (this.$l('INDEX.tips_uploadAwsSkuImage_selected_number') ||
            '本次选择了') +
          `  ${files.length}  ` +
          (this.$l('INDEX.tips_uploadAwsSkuImage_limit_picture') || '张图片')
        this.$message.warning(msg)
        return
      }

      return files
    },
    preivew(index) {
      if (this.isEmpty) return

      const viewer = this.$el.querySelector('#preview-images').$viewer
      viewer.view(index)
      viewer.show()
    },
    check(item) {
      this.$emit('check', item)
    },
    async remove({ amzSkuImgCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return

      this.loadingOpen()
      const res = await this.$api
        .ecomAmzSkuImageDelApi({ amzSkuImgCode })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })

      this.getData()
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
.aws-sku-edit-images {
  height: calc(100vh - 460px);
  min-height: 460px;
  overflow-y: auto;

  .aws-sku-edit-images-wrapper {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    .aws-sku-edit-images-item {
      .aws-sku-edit-images-item-box {
        position: relative;
        display: flex;
        border-radius: 6px;
        border: 1px solid #c0ccda;
        .el-image {
          width: 140px;
          height: 140px;
        }

        .aws-sku-edit-images-item-shadow {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          right: 0;
          bottom: 0;
          top: 0;
          left: 0;
          border-radius: 6px;
          opacity: 0;
          transition: opacity 0.3s;

          i {
            color: #fff;
            font-size: 20px;
            cursor: pointer;
          }
        }
      }

      .aws-sku-edit-images-item-box:hover {
        .aws-sku-edit-images-item-shadow {
          background-color: rgba(0, 0, 0, 0.5);
          opacity: 1;
        }
      }
    }
  }

  .aws-sku-edit-images-empty {
    height: calc(100vh - 510px);
    min-height: 420px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
